export const GENERIC_ERROR = 'error.status.generic';
export const ERRORS: Record<string | number, string> = {
  400: 'status.bad_request',
  401: 'status.unauthorized',
  404: 'status.record_not_found',
  422: 'status.unprocessable_entity',
  423: 'status.record_locked',
  500: 'status.internal_server_error',
  502: 'status.network_error',
  503: 'status.maintenance',
  [GENERIC_ERROR]: 'status.generic_error',
};

export const ERRORS_FOR_ACTION: Record<string | number, string> = {
  ...ERRORS,
};

export const ERROR_MESSAGE_REQUIRED = 'field_required';
export const ERROR_MESSAGE_INVALID_EMAIL = 'invalid_email';
export const ERROR_MESSAGE_INVALID_PHONE = 'invalid_phone';
export const ERROR_MAX_CHARACTERS_2 = 'max_2';
export const ERROS_MAX_CHARACTERS_30 = 'max_30';
export const ERROR_MESSAGE_MIN_8 = 'min_8';
export const ERROR_MESSAGE_INVALID_PASSWORD_CONFIRMATION =
  'invalid_password_confirmation';
